import styles from "./Disclaimer.module.sass";
import cn from "classnames";

const Disclaimer = ({ children, className }) => {
	return (
		<div className={cn(className, styles.disclaimer)}>
			<p>{children}</p>
		</div>
	);
};

export default Disclaimer;
